<template>
    <div
        :class="modalOverLayClass"
        @mousedown.self="onClickOutside"
    >
        <component
            v-if="isIndependent"
            :is="modalComponent"
            @close="close"
        />
        <div
            v-else
            :class="containerClasses"
        >
            <div class="modal__header">
                <component
                    v-if="hasCustomHeader"
                    :is="header.component"
                    :isTextTitle="header.isTextTitle"
                    :title="title"
                    :isHelpDisplayed="header.isHelpDisplayed"
                />
                <div
                    v-else
                    class="modal__title"
                >
                    <span
                        class="block capitalize"
                        v-html="translationBoldFormat($t(title))"
                    ></span>
                </div>
                <Icon
                    v-if="isClosable"
                    @click="close"
                    class="sds-icon-navigation-close"
                />
            </div>
            <SpinnerContainer v-if="isLoading" />
            <component
                v-else
                :is="modalComponent"
                @close="close"
            />
        </div>
    </div>
</template>

<script>
    import {
        getKey,
        Keys,
    } from '@superbet-group/web.lib.vue-utilities';
    import { translationBoldFormat } from '@superbet-group/web.lib.utilities';

    export default {
        emits: ['close'],
        props: {
            code: {
                type: String,
                required: true,
            },
            modalComponent: {
                type: [Object, Function],
                required: true,
            },
            header: {
                type: Object,
                required: false,
                default: () => ({}),
            },
            setModal: {
                type: Function,
                required: true,
            },
            containerClass: {
                type: String,
                required: false,
                default: '',
            },
            title: {
                type: String,
                required: false,
                default: '',
            },
            group: {
                type: String,
                required: false,
                default: null,
            },
            goBack: {
                type: Boolean,
                required: false,
            },
            // Used when the component itself will be the modal. No header or container around it
            isIndependent: {
                type: Boolean,
                default: false,
            },
            isClosable: {
                type: Boolean,
                default: true,
            },
            isLoading: {
                type: Boolean,
                default: false,
            },
        },
        created() {
            this.modalOverLayClass = 'modal__overlay';
        },
        mounted() {
            document.addEventListener('keyup', this.onKeyup);
        },
        computed: {
            containerClasses() {
                const classes = ['modal__container'];
                if (this.containerClass) {
                    classes.push(this.containerClass);
                }
                return classes;
            },
            hasCustomHeader() {
                return !!this.header?.component;
            },
        },
        methods: {
            close() {
                this.$emit('close', { group: this.group });
            },
            onClickOutside(event) {
                if (!this.isClosable) {
                    return;
                }
                if (event.target.className === this.modalOverLayClass) {
                    this.close();
                }
            },
            onKeyup(event) {
                if (!this.isClosable) {
                    return;
                }
                const key = getKey(event);
                if (key === Keys.ESC) {
                    this.close();
                }
            },
            translationBoldFormat,
        },
        destroyed() {
            document.removeEventListener('keyup', this.onKeyup);
        },
    };
</script>
<style scoped lang="scss">
    @import '~@superbet-group/web.lib.global-styles/responsive';
    @include respond-to-above(tMd, true) {
        .modal__overlay .spinner-container {
            max-width: 400px;
            margin: auto;
            margin-top: 100px;
        }
    }
</style>
